import { DMNDataSource, DMNResolutionContext } from './types'

export function resolveDataSource(
  dataSource: DMNDataSource,
  context: DMNResolutionContext
): string | undefined {
  switch (dataSource.source) {
    case 'activity_value': {
      const activity = context.activities.find(
        (a) => a.uuid_activity_model === dataSource.identifier
      )
      return activity?.des
    }
    case 'query_string': {
      const value = context.queryParams[dataSource.identifier]
      return value ?? undefined
    }
    case 'process_variable': {
      return context.processDataContainer[dataSource.identifier]
    }
    case 'static': {
      return dataSource.identifier
    }
  }
}

export function resolveData(
  data: { [variableName: string]: DMNDataSource },
  context: DMNResolutionContext
): { [variableName: string]: string | undefined } {
  return Object.fromEntries(
    Object.entries(data).map(([name, source]) => [
      name,
      resolveDataSource(source, context)
    ])
  )
}
